<template>
  <div class="common-page order-management">
    <div class="top-box">
      <div class="search-form-box">
        <el-row :gutter="30">
          <el-form inline>
            <el-col :span="5">
              <el-form-item label="线路地址:" prop="keyword">
                <el-input
                  style="width: 100%"
                  clearable
                  v-model="searchForm.keyword"
                  autocomplete="off"
                  placeholder="请输入" />
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="">
                <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                <el-button type="default" round icon="el-icon-refresh" @click="handleReset()"></el-button>
                <el-button type="primary" @click="handleAdd()">新增路线</el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </div>
    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange">
        <template v-slot:startProvinceName="{ row }">
          <span>{{ row.startCityName }}-{{ row.endCityName }}</span>
        </template>
        <template v-slot:companies="{ row }">
          <span v-for="(item, index) in row.companies" :key="item.companyId">
            {{ item.companyName
            }}
            <span v-if="index !== row.companies.length - 1">、</span>
          </span>
        </template>
        <template v-slot:operation="{ row }">
          <span class="operate-btn" @click="handleEdit(row)">编辑</span>
          <span class="operate-btn" @click="handleDelete(row.lineId)">删除</span>
        </template>
      </custom-table>
    </div>

    <!--    添加或编辑-->
    <addOrEdit ref="addOrEdit"></addOrEdit>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import addOrEdit from "./addOrEdit.vue";
import { getPage, deleteInfo } from "./api";
import tableMixin from "@/mixin/tableMixin";
import { getSelectCompany } from "@/views/SystemManagement/CompanyManagement/api";

export default {
  name: "CarrierRouteConfig",
  mixins: [tableMixin],
  components: {
    OperateBox,
    CustomTable,
    CustomDateRange,
    addOrEdit,
  },
  data() {
    return {
      getTableMethod: getPage,
      deleteMethod: deleteInfo,
      searchForm: {
        keyword: "",
      },
      companyList: [],
      isImmediatelyGetData: true,
      tableColumn: [
        {
          label: "线路",
          prop: "startProvinceName",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "创建时间",
          prop: "createTime",
          align: "left",
          show: true,
        },
        {
          label: "创建人",
          prop: "createUsername",
          align: "left",
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "160px",
          scopeStatus: true,
          show: true,
        },
      ],
      statisticsImage1: require("@/assets/imgs/huozhuzongliang.png"),
      statisticsImage2: require("@/assets/imgs/youxiaohuozhu.png"),
      statisticsImage3: require("@/assets/imgs/xiadanbishu.png"),
      statisticsImage4: require("@/assets/imgs/dingdanwancheng.png"),
      statisticsImage5: require("@/assets/imgs/leijijine.png"),
    };
  },
  created() {
  },
  mounted() {},
  methods: {
  },
};
</script>
<style lang="scss" scoped>
.order-management {
  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }

  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }

  .owner-requirement {
    background-color: rgba(217, 236, 255, 0.5);
    color: #1269ff;
    padding: 0.05rem;
    border-radius: 0.06rem;
  }

  .mileage {
    position: relative;
    padding: 0 0.05rem 0.06rem;
  }

  .mileage::after {
    content: "→";
    position: absolute;
    left: 0;
    bottom: -0.06rem;
    text-align: center;
    width: 100%;
  }
  .statistics-box {
    display: flex;
    justify-content: space-around;
    padding: 0 0.16rem;
    margin: 0 -0.1rem;
    .statistics-list {
      width: 33.33%;
      height: 1.2rem;
      background-color: #ffffff;
      border-radius: 0.08rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.2rem;
      box-sizing: border-box;
      margin: 0 0.1rem;
      .statistics-image {
        width: 0.8rem;
        height: 0.61rem;
      }
      .statistics-num {
        .num {
          font-size: 0.24rem;
          color: #000000;
          font-weight: bold;
        }
        .txt {
          font-size: 0.14rem;
          color: #434343;
          padding-top: 0.1rem;
        }
      }
    }
  }
  .custom-table-box {
    padding-top: 0;
  }
}
</style>
